import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../../hooks/useNotifications'
import { redactAllUserMessages } from '../../../../services/chatService'

export default function RedactAllMessagesOverlay({ cisId, refreshMessages, ...overlay }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()

  const submitOnClick = async () => {
    overlay.close()
    try {
      await redactAllUserMessages(cisId)
      ok(t('user.messages.redactAllUserMessagesSuccess', 'Success redacting all user messages'))
      refreshMessages()
    } catch (err) {
      error(
        `${t('user.messages.redactAllUserMessagesFailure', {
          defaultValue: `Failed to redact all user messages`,
        })}${err.message && `: ${err.message}`}`,
        err
      )
    }
  }

  return (
    <DialogOverlay title={t('action.redactAll', 'Redact All')} {...overlay}>
      <Paragraph size="sm">
        {t('user.messages.redactAllUserMessagesConfirmation', 'Are you sure you want to redact all user messages?')}
      </Paragraph>
      <DialogOverlayActions>
        <Button onClick={submitOnClick} emphasis="high">
          {t('action.submit', 'Submit')}
        </Button>
        <Button onClick={overlay.close}>{t('action.cancel', 'Cancel')}</Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
